<template>
  <div class="getTopic">
      <div class="getTopicbox">
          <!--出题列表-->
          <div class='box' v-for="(topics,index) in list"  :key="index">
              <div class="title">{{topics.title}}</div>
              <div class="item1" @click="onChange(topics.id,'1')">{{topics.item1}}</div>
              <div class="item1" @click="onChange(topics.id,'2')">{{topics.item2}}</div>
          </div>
          <!-- 弹窗 -->
          <div class='tipbox' v-show="tipbox=='1'">
            <!-- 取消订单弹窗 -->
            <div class="tip" v-show='two=="1"'>
              <p class="tipTitle">是否要取消订单？</p>
              <p class='tipbtnbox'><span class='close'>暂不取消</span><span class='tipbtn'>确认取消</span></p>
            </div>
            <!-- 客服电话弹窗 -->
            <div class="phone">
              <p class="title">客服电话 010-3687201</p>
              <p class="time">工作日时间：周一至周五9:00-18:00</p>
              <p class="phoneBtn">拨打客服电话</p>
            </div>
          </div>   
          <!--没有订单，占位符  -->
          <div class='kong' v-if="list== undefined  ||  list.length <= 0">
            <img class="kongpic" src="../../assets/img/shoppingMall/orderListkong.png" alt="">
            <p>你还没有相关的订单</p>
          </div>
      </div> 
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import Swiper from "swiper";
import { Loadmore } from 'mint-ui';
import toastDownloadPage from '../commen/toastDownloadPage'
import cbct from '../../assets/js/common/base.js';
export default {
  name: 'getTopic',
  data:function(){
    return{
      list:[
        {
          id:'1',
          title:'嘻嘻哈哈1',
          item1:'答案11',
          item2:'答案21'
        },
        {
          id:'3',
          title:'嘻嘻哈哈2',
          item1:'答案12',
          item2:'答案22'
        },
        {
          id:'5',
          title:'嘻嘻哈哈3',
          item1:'答案13',
          item2:'答案23'
        },
      ],
      newlist:[],
      a:'1',
      b:'1',
      tipbox:'0',
      two:'0',
    }
  },

  methods:{
    //选中的题目和答案
     onChange:function(id,value){
       var self =this;
       this.$set(self.newlist,id,value);
        console.log(self.newlist)
      },
      //获取答题列表
    getlist:function(){
        var self = this;
            self.api.get(cbct.https()+'/activity/valentine-topics').then((response)=>{
              if(response.c == this.cbct.code.successRes){
                  console.log(response.d)
              }else if(response.c == this.cbct.code.noLogin){
                  Toast({
                      message: response.m,
                      position: 'center',
                      duration: 5000
                  });
                  timing.time();
              }else if(response.c ==this.cbct.code.raleNoLogin){
                 
              }else{
                Toast({
                      message: response.m,
                      position: 'center',
                      duration: 5000
                  });
              }
              
          }
          ).catch((error)=>{console.log(error);})


    },
    //上传题目
    uploadTopics:function(){
         self.http.post(self.cbct.https()+'/activity/valentine-my-topic', self.qs.stringify({
               topic:self.newlist
            })).then((response)=>{
                if(response.c == self.cbct.code.successRes){  
                  console.log(response.d)
                    
                }else if(response.c == self.cbct.code.noLogin){
                    Toast({
                        message:response.m ,
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == self.cbct.code.raleNoLogin){
                    this.loginbtn();                  
                }else{
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 1000
                    });
                }
                
            }
            ).catch((error)=>{this.toast(error);})
    },
    
  },
  created(){
    var self = this;
    //判断是否授权
    if(this.cbct.getCookie('openId') == undefined ||this.cbct.getCookie('openId') == ''){
        this.$router.push({path:'./change?channel_id='+this.$route.query.Truechnnel_id});
    }
    this.timing.time();
    $('title').html('我要出题');
    // 缓存数组长度，进一步提升代码性能
    var len = self.list.length;
    var result = [];
    for (var i = 0; i < len; i++) {
        result= self.list['0']
    };
    
    console.log(result);
  },
  mounted(){
      
  },
  components:{

  }
  
}


</script>
<style scoped lang="scss">
  .getTopic{
    width: 100%;
    height: 100%;
    .getTopicbox{
      margin: .2rem .3rem 0;
      height: 100%;
      position: relative;
      .kong{
        width: 100%;
        height: 100%;
        justify-content: center;
        .kongpic{
          width: 1.2rem;
          height: 1.2rem;
          margin-top: 4.4rem;
        }
        p{
          font-size: .24rem;
          margin-top: .2rem;
          color: rgba($color: #000000, $alpha: .8)
        }
      }
      .box{
        width:100%;
        height: 4rem;
        background: #fff;
        margin-bottom: .2rem;
        border-radius: .1rem;
      }
      .tipbox{
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:rgba(3,3,3,0.5);
        overflow: hidden;
        .tip{
          width: 6rem;
          height: 2.9rem;
          border-radius: .16rem;
          background: #fff;
          margin: 4rem auto 0;
          box-sizing: border-box;
          .tipTitle{
            width: 100%;
            font-size:.34rem;
            color: #333;
            height: 1.84rem;
            line-height: 1.84rem;
            font-weight: 600;
            border-bottom: 1px solid rgba($color: #000000, $alpha: .2)
          }
          .tipbtnbox{
            display: flex;
            overflow: hidden;
            span{
              display: inline-block;
              width:3rem;
              font-size: .32rem;
              height: 1.03rem;
              line-height: 1.03rem;
            }
            .close{
              color: rgba($color: #000000, $alpha: .5);
              border-right: 1px solid rgba($color: #000000, $alpha: .2);
            }
            .tipbtn{
              color: #4473E1;
            }
          }
        }
        .phone{
          width: 6rem;
          height: 3.68rem;
          border-radius: .16rem;
          background: #fff;
          margin: 3.5rem auto 0;
          box-sizing: border-box;
          display: block;
          overflow: hidden;
          .title{
           
            font-size: .34rem;
            color: #333;
            margin: .76rem auto .32rem;
            line-height: .48rem;
          }
          .time{
            font-size:.32rem;
            color: rgba($color: #000000, $alpha: .5);
            margin-bottom: .68rem;
            line-height: .44rem;
          }
          .phoneBtn{
            font-size: .32rem;
            color: #4473E1;
            padding: .3rem;
            font-weight: 600;
            border-top:1px solid rgba($color: #000000, $alpha: .2);
          }
        }
      }
    }
 }
</style>

